
import * as React from 'react';
import PropTypes from 'prop-types';

import { isPresent } from 'helpers/string_helpers';

export default function Details({ requirement }) {
  const capitalize = s => (s[0].toUpperCase() + s.slice(1));

  const renderRequirementDetails = (details, id) => {
    return details.map((detail, index) => (
      <span key={id + detail}>
        {detail}{index === (details.length - 1) ? '' : '∙'}
      </span>
    ));
  };

  const renderBuyRequirement = (requirement) => {
    const requirementsDetails = [];

    if (isPresent(requirement.transactionType)) {
      requirementsDetails.push(capitalize(requirement.transactionType));
    }

    requirementsDetails.push(
      requirement.propertyTypes,
      requirement.buildingSize,
      requirement.lotSize,
      requirement.salePrice,
      requirement.numberOfUnits,
      requirement.investmentTypeLabels,
      requirement.locationFormatted,
      requirement.polygonSearch ? 'Map Drawing' : ''
    );

    return (
      <div className="d-inline-block">
        {renderRequirementDetails(requirementsDetails.filter(Boolean), requirement.id)}
      </div>
    );
  };


  const renderLeaseRequirement = (requirement) => {
    const requirementsDetails = [];

    requirementsDetails.push(
      isPresent(requirement.transactionType) ? capitalize(requirement.transactionType) : '',
      requirement.propertyTypes,
      requirement.buildingSize,
      requirement.lotSize,
      requirement.numberOfUnits,
      requirement.leaseDate,
      requirement.investmentTypeLabels,
      requirement.locationFormatted,
      requirement.polygonSearch ? 'Map Drawing' : ''
    );

    return (
      <div className="d-inline-block">
        {renderRequirementDetails(requirementsDetails.filter(Boolean), requirement.id)}
      </div>
    );
  };

  const renderRequirement = () => (
    <>
      {requirement.transactionType === 'sale' ? renderBuyRequirement(requirement) : renderLeaseRequirement(requirement)}
    </>
  );

  return (
    <>
      {renderRequirement()}

      {isPresent(requirement.notes) &&
        <div className="mt-2">
          <span className="text-muted">
            NOTES: {requirement.notes}
          </span>
        </div>
      }
    </>
  );
}

Details.propTypes = {
  requirement: PropTypes.shape({
    buildingSize: PropTypes.string,
    id: PropTypes.number.isRequired,
    investmentTypeLabels: PropTypes.string,
    leaseDate: PropTypes.string,
    locationFormatted: PropTypes.string,
    lotSize: PropTypes.string,
    name: PropTypes.string.isRequired,
    notes: PropTypes.string,
    numberOfUnits: PropTypes.string,
    polygonSearch: PropTypes.bool,
    propertyTypes: PropTypes.string,
    salePrice: PropTypes.string,
    searchPath: PropTypes.string.isRequired,
    transactionType: PropTypes.string.isRequired
  }).isRequired
};
